"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.safeElements = void 0;
var variables_1 = require("./dom-variables/variables");
var element_from_string_1 = require("./element-from-string");
function safeElements(selector, context) {
    var array = [];
    if (!selector)
        return array;
    var eles = selector;
    if (typeof selector === 'string') {
        var ctx = context || document;
        eles = variables_1.idRe.test(selector)
            ? ctx.getElementById(selector.slice(1))
            : variables_1.htmlRe.test(selector)
                ? element_from_string_1.elementsFromString(selector)
                : ctx.querySelector(selector);
        if (!eles)
            return array;
    }
    if (eles.nodeType || eles === variables_1.win)
        eles = [eles];
    for (var i = 0, l = eles.length; i < l; i++) {
        array[i] = eles[i];
    }
    return array;
}
exports.safeElements = safeElements;
//# sourceMappingURL=safe-element.js.map